import React, {  useEffect ,useRef, Suspense } from "react";
import { Outlet } from "react-router-dom";
import { useUser } from "contexts/UserContext";
import { useMainState } from "contexts/MainStateContext";
import ModalManager from "components/Modal/ModalManager";
import CTHeader from "components/CTHeader";


import CTRightMenu from "components/CTRightMenu";

export default function MainLayout() {
  
 const { user, menuMapR, loadingMenus } = useUser();
 const { mainState, setMainState } = useMainState();
 const rightMenuRef = useRef(null);

// Click outside right menu
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        rightMenuRef.current &&
        !rightMenuRef.current.contains(e.target) &&
        !e.target.closest("#configButton")
      ) {
        setMainState((prev) => ({ ...prev, showRightMenu: false }));
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [setMainState]);



  return (
    <div className="flex flex-col h-screen overflow-hidden">
      {/* Header */}
      <CTHeader variant="vibrant" />

         {/* Contenido dinámico */}
    <main className="flex-1 bg-gray-50 p-0 min-h-0 relative">
      <Suspense fallback={<div>Cargando...</div>}>
        <div className="h-full w-full overflow-hidden relative">
          <Outlet />
        </div>
      </Suspense>
    </main>


      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-3 px-6">
        <div className="flex items-center justify-between">
          <span className="text-sm text-gray-600">
            © 1985 - {new Date().getFullYear()} Toni Raventós - v1.0.0
          </span>
          <span className="text-sm text-gray-600">
            Usuario: {user?.name} | Empresa: {user?.empresa}
          </span>
        </div>
      </footer>

      {/* Right Menu */}
          {mainState.showRightMenu && menuMapR.size > 0 && (
            <div
              ref={rightMenuRef}
              className="absolute top-14 right-0 w-80 p-0 gap-2 z-50 border border-gray-300 rounded-md bg-white dark:bg-gray-900"
            >
              <CTRightMenu menuMapR={menuMapR} />
            </div>
          )}
      {/* Modales globales */}
      <ModalManager />
    </div>
  );
}